






















































































































































































import { defineComponent, ref, computed, PropType } from '@vue/composition-api';
import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';
import { IRootState } from '@/store';

import {
  IDepartment,
  IGLAccount,
  IPaymentRequisitionLineData,
  IRequisitionLineData,
  ISystemError,
  RequisitionLine
} from '@/models';
import { useVModel } from '@vueuse/core';
import {
  IGLAccountActions,
  IGLAccountGetters,
  IGLAccountMutations,
  IGLAccountState
} from '@/store/accounting';

import { defaultFilter, getObjectValueByPath } from '@/utils/helpers';
import { requiredValidator } from '@/utils/validators';
export enum RequisitionType {
  Purchase = 'purchase',
  Payment = 'payment'
}
export default defineComponent({
  name: 'RequisitionLineFormFields',

  props: {
    line: {
      type: Object as PropType<
        IRequisitionLineData | IPaymentRequisitionLineData
      >,
      required: true
    },
    departments: {
      type: Array as PropType<IDepartment[]>,
      required: true
    },

    accounts: {
      type: Array as PropType<IGLAccount[]>,
      required: true
    },

    error: {
      type: Object as PropType<ISystemError>,
      default: () => {}
    },

    requisitionType: {
      type: String as PropType<RequisitionType>,
      default: RequisitionType.Purchase
    },

    canEditLine: {
      type: Boolean,
      default: true
    }
  },

  emits: {
    clearError: () => true
  },

  setup(props, { emit }) {
    const requisitionLineItem = useVModel(props, 'line', emit, {
      passive: true,
      defaultValue: new RequisitionLine()
    });

    const unitOfMeasureList = ref([
      { uom: 'BAG', description: 'Bag' },
      { uom: 'BX', description: 'Box' },
      { uom: 'CA', description: 'Case' },
      { uom: 'CMT', description: 'Hundred Meters' },
      { uom: 'COL', description: 'Coil' },
      { uom: 'CTN', description: 'Carton' },
      { uom: 'EA', description: 'Each' },
      { uom: 'FT', description: 'Foot' },
      { uom: 'FT2', description: 'Square Feet' },
      { uom: 'GA', description: 'Gallons' },
      { uom: 'IN', description: 'Inch' },
      { uom: 'KG', description: 'Kilogram' },
      { uom: 'LB', description: 'Pound' },
      { uom: 'LOT', description: 'Lot' },
      { uom: 'M', description: 'Meter' },
      { uom: 'M2', description: 'Square Meter' },
      { uom: 'MM', description: 'Millimeter' },
      { uom: 'OZ', description: 'Ounces' },
      { uom: 'PKG', description: 'Package' },
      { uom: 'REL', description: 'Reel' },
      { uom: 'RL1', description: 'Roll' },
      { uom: 'ROL', description: 'Rolls' },
      { uom: 'SH', description: 'Sheet' },
      { uom: 'WKS', description: 'Weeks' }
    ]);

    const store = useStore<IRootState>();

    const { useGetters } = createNamespacedHelpers<
      IGLAccountState,
      IGLAccountGetters,
      IGLAccountActions,
      IGLAccountMutations
    >(store, 'accounting');

    const { getGLAccountsByDepartment } = useGetters([
      'getGLAccountsByDepartment'
    ]);

    const filteredAccounts = computed<IGLAccount[]>(() => {
      if (requisitionLineItem.value.department) {
        const department =
          typeof requisitionLineItem.value.department === 'number'
            ? requisitionLineItem.value.department
            : requisitionLineItem.value.department.id!;
        return getGLAccountsByDepartment.value(department);
      }

      return props.accounts;
    });

    const lineTotal = computed(() => {
      return (
        ((props.line as IRequisitionLineData).quantity || 0) *
        Number((props.line as IRequisitionLineData).unit_price || 0)
      );
    });

    function clearError() {
      emit('clearError');
    }

    function clearAccountIfNotValid() {
      clearError();

      if (!requisitionLineItem.value.account) return;

      requisitionLineItem.value.account = null;
    }

    function filter(
      item: Record<string, any>,
      queryText: string,
      _itemText: string
    ) {
      const filterList = ['code', 'name', 'code-name', 'codename', 'code_name'];
      // added proxy filter and value keys to filter by
      item['code-name'] = `${item.code} - ${item.name}`;
      item['codename'] = `${item.code}${item.name}`;
      item['code_name'] = `${item.code} ${item.name}`;
      return filterList.some(key =>
        defaultFilter(getObjectValueByPath(item, key), queryText, item)
      );
    }

    return {
      descriptionRules: [
        (v: string) => v.length <= 2000 || 'Max 2000 characters'
      ],
      filter,
      unitOfMeasureList,
      filteredAccounts,
      lineTotal,
      clearError,
      clearAccountIfNotValid,
      requiredValidator,

      RequisitionType
    };
  }
});
